// @flow

import React from 'react';
import { useCopy } from 'hooks/useCopy';

import { Button, Paragraph, Notice, Link } from 'operation-diameter';
import styles from './LoginNotice.module.css';

type Props = {
  magicLinkProcessing: boolean,
  onSendMagicLinkClick: (
    event: SyntheticEvent<HTMLButtonElement>
  ) => Promise<void>,
  showMFALoginOption: boolean
};

const MFALoginOption = () => {
  const { getCopy } = useCopy();

  return (
    <Link data-testid='login-with-password' href='/login'>
      {getCopy('contactDetails.loginNotice.loginWithPassword')}
    </Link>
  );
};

const MagicLinkLoginOption = (magicLinkProcessing, onSendMagicLinkClick) => (
  <div className={styles.magicLinkNotice}>
    <Paragraph>
      Get a secure link emailed that’ll log you in instantly, or use your
      password.
    </Paragraph>
    <div className={styles.magicLinkContainer}>
      <Button
        additionalClassnames={styles.sendSecureLink}
        onClick={onSendMagicLinkClick}
        isLoading={magicLinkProcessing}
        data-process-text='Processing'
        data-testid='send-secure-link'>
        Send secure link
      </Button>
      <Paragraph>or</Paragraph>
      <Link data-testid='or-login-with-password' href='/login'>
        Login with password
      </Link>
    </div>
  </div>
);

const LoginNotice = ({
  magicLinkProcessing,
  onSendMagicLinkClick,
  showMFALoginOption
}: Props) => {
  const { getCopy } = useCopy();

  return (
    <Notice
      variant='info'
      heading={getCopy('contactDetails.loginNotice.alreadyHaveAccount')}
      data-testid='already-have-account'>
      {showMFALoginOption
        ? MFALoginOption()
        : MagicLinkLoginOption(magicLinkProcessing, onSendMagicLinkClick)}
    </Notice>
  );
};
LoginNotice.displayName = 'LoginNotice';

export default LoginNotice;
